// extracted by mini-css-extract-plugin
export default {"mCard":"PC-z","image":"QC-z","imageNoBackground":"RC-z","imageHasCategory":"SC-z","fullWidth":"TC-z"};